var PaginatedResultsLoader = /** @class */ (function () {
    function PaginatedResultsLoader(queryFunc) {
        this._results = [];
        this._cursor = null;
        this._hasMoreResults = false;
        this._queryFunc = queryFunc;
    }
    Object.defineProperty(PaginatedResultsLoader.prototype, "cursor", {
        get: function () {
            return this._cursor;
        },
        set: function (v) {
            this._cursor = v;
        },
        enumerable: true,
        configurable: true
    });
    PaginatedResultsLoader.prototype.hasMoreResults = function () {
        return this._hasMoreResults;
    };
    PaginatedResultsLoader.prototype.getResults = function () {
        var _this = this;
        return this._queryFunc(this.cursor)
            .then(function (resultList) { return _this.handleResultsLoaded(resultList); });
    };
    PaginatedResultsLoader.prototype.handleResultsLoaded = function (resultList) {
        this._results = this._results.concat(resultList.results);
        this._cursor = null;
        this._hasMoreResults = false;
        if (typeof resultList.cursor === "string") {
            this._cursor = resultList.cursor.trim();
            this._hasMoreResults = this._cursor != "";
        }
        return this._results;
    };
    PaginatedResultsLoader.prototype.loadMore = function () {
        return this.getResults();
    };
    return PaginatedResultsLoader;
}());
export { PaginatedResultsLoader };



// WEBPACK FOOTER //
// ./src/app/shared/models/paginated-results-loader.ts.pre-build-optimizer.js